export enum MapMarkerType {
    TRANSACTION = 'TRANSACTION',
    COUNTER = 'COUNTER'
}